"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    MyTripsList: ()=>MyTripsList
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const index_js_namespaceObject = require("../../constants/index.js");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_TripCard_js_namespaceObject = require("./TripCard.js");
const external_getPackageTrips_js_namespaceObject = require("./getPackageTrips.js");
const external_myTripDataContext_js_namespaceObject = require("./myTripDataContext.js");
const external_formatTripMessageContent_js_namespaceObject = require("./formatTripMessageContent.js");
const StyledTripsLinkCard = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Card).withConfig({
    displayName: "MyTripsList__StyledTripsLinkCard"
})([
    "cursor:pointer;"
]);
const MyTripsList = (props)=>{
    const { trips, tripCategory } = props;
    const { deepLinkPrompt, submitChatMessageInMarkerComponent } = (0, external_react_namespaceObject.useContext)(external_myTripDataContext_js_namespaceObject.myTripContextData);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: trips.sort((a, b)=>new Date(a.travelStartDate).getTime() - new Date(b.travelStartDate).getTime()).map((trip, index)=>{
            const { checkStatusUrl, type } = trip;
            const isPackage = type === index_js_namespaceObject.productsType.PACKAGE;
            const actualCheckStatusUrl = `${checkStatusUrl}${deepLinkPrompt || ''}`;
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Animate, {
                variant: 'slideInLeft',
                override: {
                    transition: {
                        delay: 0.1 * index || 0
                    }
                },
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StyledTripsLinkCard, {
                    "data-testid": `trip-link-card-${tripCategory}-${index}`,
                    onClick: function(event) {
                        event.preventDefault();
                        if (submitChatMessageInMarkerComponent) submitChatMessageInMarkerComponent({
                            role: 'user',
                            content: (0, external_formatTripMessageContent_js_namespaceObject.formatTripMessageContent)(trip)
                        }, []);
                        else window.open(actualCheckStatusUrl);
                    },
                    borderWidth: 0,
                    width: 1,
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TripCard_js_namespaceObject.TripCard, {
                        trip: isPackage ? (0, external_getPackageTrips_js_namespaceObject.getPackageTrips)(trip) : trip,
                        actualCheckStatusUrl: actualCheckStatusUrl
                    })
                })
            }, index);
        })
    });
};
exports.MyTripsList = __webpack_exports__.MyTripsList;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "MyTripsList"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
